export const API_ENDPOINTS = {
  PROFILE: {
    PROFILE_IMAGE: `profileImage/photo`,
    BANNER_IMAGE: `profileImage/banner`,
    PROFILE_DETAIL: `employee/getEmployeeProfile`,
    PROFILE_SUBMIT: `employee/updateProfileOverallSubmit`,
    //hr
    HR_PROFILE_DETAIL: (empId) => `employee/getEmployeeProfileByHR/${empId}`,
    HR_PROFILE_IMAGE: (empId) => `profileImage/hrPhoto/${empId}`,
    HR_BANNER_IMAGE: (empId) => `profileImage/hrBanner/${empId}`,
  },
  BASIC_DETAILS: {
    FETCH_BASIC_DETAILS: `users/basic-info`,
    EDIT_BASIC_DETAILS: `users/basic-info`,
    //hr
    HR_FETCH_BASIC_DETAILS: (empId) => `users/basic-info/hr/${empId}`,
    HR_EDIT_BASIC_DETAILS: (empId) => `users/basic-info/hr/${empId}`,
  },
  HR_INFORMATION: {
    FETCH_REPORTING_MANAGER: `users/hr-info/reporting-manager`,
    FETCH_DIVISION_HEAD: `users/hr-info/division-head`,
    FETCH_REVIEWER: `users/hr-info/reviewer`,
    FETCH_HR_INFO: `users/hr-info`,
    EDIT_HR_INFO: `users/hr-info`,
    //HR api
    HR_FETCH_HR_INFO: (empId) => `users/hr-info/hr/${empId}`,
    HR_EDIT_HR_INFO: (empId) => `users/hr-info/hr/${empId}`,
  },
  CONTACT: {
    FETCH_CONTACT_DETAILS: `users/contact-info`,
    EDIT_CONTACT_DETAILS: `users/contact-info`,
    //HR Api
    HR_FETCH_CONTACT_DETAILS: (empId) => `users/contact-info/hr/${empId}`,
    HR_EDIT_CONTACT_DETAILS: (empId) => `users/contact-info/hr/${empId}`,
  },
  WORKING_INFORMATION: {
    FETCH_WORKING_INFO: `users/work-info`,
    // EDIT_WORKING_INFO: `users/work-info`,
    //HR api
    HR_FETCH_WORKING_INFO: (empId) => `users/work-info/hr/${empId}`,
    HR_EDIT_WORKING_INFO: (empId) => `users/work-info/hr/${empId}`,
    SHIFT_MASTER: `shift-master/get-ShiftByOrg`,
  },
  ACCOUNT_INFORMATION: {
    FETCH_ACCOUNT_INFO: `users/account-info`,
    EDIT_ACCOUNT_INFO: `users/account-info`,
    //HR api
    HR_FETCH_ACCOUNT_INFO: (empId) => `users/account-info/hr/${empId}`,
    HR_EDIT_ACCOUNT_INFO: (empId) => `users/account-info/hr/${empId}`,
  },
  EDUCATION: {
    FETCH_EDUCATION: `users/edu-info`,
    FETCH_IMAGE: (folderName, fileName) =>
      `users/docs/${folderName}/${fileName}`,
    ADD_EDUCATION: `users/edu-info`,
    UPDATE_EDUCATION: (eduId) => `users/edu-info/${eduId}`,
    DELETE_EDUCATION: `users/edu-info`,
    EDUCATION_DROPDOWN: (id) =>
      id
        ? `module-settings/qualification?referenceName=qualificationsAndCourses&moduleId=${id}`
        : `module-settings/qualification?referenceName=qualificationsAndCourses`,
    //HR api
    HR_FETCH_EDUCATION: (empId) => `users/edu-info/hr/${empId}`,
    HR_ADD_EDUCATION: (empId) => `users/edu-info/hr/${empId}`,
    HR_UPDATE_EDUCATION: (empId, eduId) =>
      `users/edu-info/hr/${empId}/${eduId}`,
    HR_DELETE_EDUCATION: `users/edu-info/hr`,
  },
  EXPERIENCE: {
    FETCH_EXPERIENCE: `users/exp-info`,
    FETCH_IMAGE: (folderName, fileName) =>
      `users/docs/${folderName}/${fileName}`,
    ADD_EXPERIENCE: `users/exp-info`,
    UPDATE_EXPERIENCE: (expId) => `users/exp-info/${expId}`,
    DELETE_EXPERIENCE: `users/exp-info`,
    //HR api
    HR_FETCH_EXPERIENCE: (empId) => `users/exp-info/hr/${empId}`,
    HR_ADD_EXPERIENCE: (empId) => `users/exp-info/hr/${empId}`,
    HR_UPDATE_EXPERIENCE: (empId, expId) =>
      `users/exp-info/hr/${empId}/${expId}`,
    HR_DELETE_EXPERIENCE: `users/exp-info/hr`,
  },
  FAMILY: {
    FETCH_FAMILY: `users/family-info`,
    ADD_FAMILY: `users/family-info`,
    UPDATE_FAMILY: `users/family-info`,
    DELETE_FAMILY: `users/family-info`,

    //HR api
    HR_FETCH_FAMILY: (empId) => `users/family-info/hr/${empId}`,
    HR_ADD_FAMILY: (empId) => `users/family-info/hr/${empId}`,
    HR_UPDATE_FAMILY: (empId) => `users/family-info/hr/${empId}`,
    HR_DELETE_FAMILY: (empId) => `users/family-info/hr/${empId}`,
    ACCEPT_INSURANCE: (relationship, status) =>
      `/payroll/insurance/accept-insurance?relationship=${relationship}&status=${status}`,
    INSURANCE_ELIGIBLE: (empId) => `/payroll/insurance/eligible?empId=${empId}`,
  },
  FOLLOW_UP: {
    FETCH_FOLLOWUP: `users/followup-info`,
    HR_FETCH_FOLLOWUP: (empId) => `/users/followup-info/hr/${empId}`,
  },
  OTHER_DOCUMENTS: {
    GET_DOCUMENT_DETAILS: `users/doc-info`,
    UPDATE_DOCUMENT: `users/doc-info`,
    //hr
    HR_GET_DOCUMENT_DETAILS: (empId) => `users/doc-info/hr/${empId}`,
    HR_UPDATE_DOCUMENT: (empId) => `users/doc-info/hr/${empId}`,
    DOCUMENT_DOWNLOAD: (folder, file) =>
      `users/doc-info/download/${folder}/${file}`,
  },
  FETCH_IMAGE: {
    FETCH_IMAGE: (folderName, fileName) =>
      `users/docs/${folderName}/${fileName}`,
  },
};
